(() => {
  if (window.pbsLoyaltyDisplay) return;
  window.pbsLoyaltyDisplay = true;
  const update = () => {
    document.querySelectorAll('.shopify-section:has(.pbs-pdp-benefits) #loyoly-points').forEach((label) => {
      const section = label.closest('.shopify-section');
      const priceBox = section.querySelector('[id^="price-"]');
      const app = label.closest('.shopify-app-block');
      if (priceBox && app && app.parentElement !== priceBox) priceBox.append(app);
      const text = label.textContent.trim();
      const match = text.match(/^Gagnez\s+([\d\s\u00a0\u202f]+)\s+points(?:\s+soit\s+(?:5|10)€)?$/i);
      if (!match) return;
      const points = Number(match[1].replace(/\s/g, ''));
      const base = text.replace(/\s+soit\s+(?:5|10)€$/i, '');
      const marker = label.closest('.shopify-section').querySelector('.pbs-pdp-benefits');
      const price = Number(marker?.dataset.pbsPrice);
      const euro = marker?.dataset.pbsCurrency === 'EUR';
      const reward = euro && price > 75000 ? 10 : points > 350 ? 5 : 0;
      const next = reward ? base + ' soit ' + reward + '€' : base;
      if (label.textContent !== next) {
        label.textContent = base;
        if (reward) {
          label.append(document.createTextNode(' soit '));
          const gain = document.createElement('strong');
          gain.textContent = reward + '€';
          label.append(gain);
        }
      }
    });
  };
  const start = () => {
    const root = document.querySelector('main') || document.body;
    update();
    new MutationObserver(update).observe(root, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();